module.exports = __webpack_public_path__ + "img/miniwiz-logo.d5b81948.png";